<template>
    <div v-show="isLoaded" class="mRecipeBook-container" v-observe-visibility="startAnimate">
        <div class="mLeft">
            <img class="mLRecipe" :src="imgRecipeBook" :class="{animate: animate}" alt="Cocteles para reuniones">
        </div>
        <div class="mRight">
            <img class="mRTitle" :src="imgTitle" :class="{animate: animate}" alt="¡Nuevos cocteles">
            <h2 class="mRSubtitle" :class="{animate: animate}">Para tus <span>reuniones!</span></h2>
            <h3 class="mRParagraph" :class="{animate: animate}">Descarga nuestro recetario de bebidas <br> deliciosas con Strongbow</h3>
            <a href="javascript:void(0)" :class="{animate: animate}" @click="onDownload()">
                <img class="mRButton" :src="imgButton" alt="Descárgalo aquí">
            </a>
            <h4 class="mRParagraph-two" :class="{animate: animate, onlySafari: isSafari}">Para recibir más contenido relacionado déjanos tu correo:</h4>
            <div class="mRecipeBook-form" :class="{animate: animate, onlySafari: isSafari}">
                <input
                    class="email"
                    ref="email"
                    type="email"
                    placeholder="nombre@gmail.com"
                    v-model="email"
                    id="email"
                />
                <div :class="{animate: animate}" @click="onEnviar()" class="mRecipeBook-button">
                    <span>Enviar</span>
                </div>
            </div>
            <div class="mRecipeBook-error" v-if="error">
                <p class="error">
                    Debes introducir un correo válido
                </p>
            </div>
            <div class="mRecipeBook-enviar" :class="{animate: animate}" v-if="exito">
                <p class="enviar">
                    Correo registrado con éxito
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import imgRecipeBook from '@/assets/recipeBook/banner-recetario.png';
import imgTitle from '@/assets/recipeBook/nuevos-cocteles.png';
import imgButton from '@/assets/recipeBook/btn-descarga.png';
import { mapGetters } from "vuex";
import Bowser from "bowser";
import axios from 'axios';
import tagFunctions from '../utils/tagFunctions';

export default {
    name: "RecipeBook",
    data() {
        return {
            imgRecipeBook,
            imgTitle,
            imgButton,
            animate: false,
            isSafari: false,
            email: '',
            error: false,
            exito: false,
        };
    },
    computed: {
        ...mapGetters(["isLoaded"]),
    },
    methods: {
        startAnimate(isVisible){
            if(isVisible){
                this.animate=true
            }
        },
        async Email(email) {
            const resp = await axios.post(`https://prod-ws-amstelnyr-int-ws-amstelnyr.azurewebsites.net/api/Campaigns/Strongbow/${email}`, {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'accept': 'application/json',
                    'content-type': 'application/json'
                }
            });
            sessionStorage.removeItem('email');
            console.log(resp)
        },
        async onEnviar() {
            if(!this.validEmail(this.email)) {
                this.error = true;
                return;
            }
            this.error = false;
            sessionStorage.setItem('email', this.email);
            await this.Email(this.email);
            this.exito = true;
            this.email = '';
            setTimeout(() => {
                this.exito = false;
            }, 2500);

        },
        validEmail: function (email) {
            const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
        onDownload() {
            const url = `https://prod-ws-amstelnyr-int-ws-amstelnyr.azurewebsites.net/api/Campaigns/Strongbow/Download`
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'Recetario StongBow.pdf')
            document.body.appendChild(link)
            link.click()
            this.onClickOptions()
        },
        onClickOptions() {
            tagFunctions.evClickOptionsPush('click_donwload_file')
        },
    },
    components: {},
    beforeMount() {
        const browser = Bowser.getParser(window.navigator.userAgent);
        if (browser.getBrowserName()=='Safari') {
            this.isSafari = true
        }
    }
};
</script>

<style scoped lang="scss">
@import "~@/styles/variables.scss";
@import "~@/styles/RecipeBook.scss";
</style>